var $c0320ddac63a91fb$exports = {};
$c0320ddac63a91fb$exports = {
    "actions": `Acciones`,
    "hideButtonLabel": `Mostrar menos`,
    "noTags": `Ninguno`,
    "showAllButtonLabel": (args, formatter)=>`Mostrar todo (${formatter.number(args.tagCount)})`
};


export {$c0320ddac63a91fb$exports as default};
//# sourceMappingURL=es-ES.mjs.map
